import type { ColorType } from 'common/helpers'
import type { FC } from 'react'
import { useEffect } from 'react'

import type { Range2D, ScaleType } from '../../../types'
import { useWebGlContext } from '../context'
import { addRender } from '../helpers'
import { useShader } from './hooks'

type PointsProps = {
  scale: ScaleType
  origin: Range2D
  size: number
  points: Float32Array
  color: ColorType
}

export const Points: FC<PointsProps> = ({ scale, origin, size, points, color }) => {
  const {
    canvas: { value: containerElement },
    renderQueue: { value: renders },
    update: { value: update, setValue: setUpdate },
    programs,
  } = useWebGlContext()

  const pointsRender = useShader(
    containerElement,
    programs,
    scale,
    origin,
    size,
    points,
    color,
    setUpdate,
  )

  useEffect(() => {
    if (!pointsRender) return

    addRender(renders, pointsRender)
  }, [pointsRender, renders, update])

  return null
}
